import React, { Component } from "react";
import { DateRangePicker, CustomProvider } from 'rsuite';
import enUS from 'rsuite/locales/en_US';
import { AsyncPaginate } from 'react-select-async-paginate';
import { callBackendAPI, generateSource } from './../../helpers/common';
import { STATUS_SUCCESS, DATE_RANGE_PICKER_FORMAT, DATERANGE_DATE_TIME_FORMAT } from './../../config/global_constants';
import { translate, formatDate } from './../../helpers/intl_helpers';

const locale = {
	...enUS,
	DateTimeFormats: {
		...enUS.DateTimeFormats,
		weekStart: 0 // Sunday
	}
};


export default class HistoryReport extends Component {
	constructor(props) {
		super(props)

		// const { weekData } = this.props;

		// Year To Date default
		const currentDate = new Date();
		const yearStartDate = new Date(currentDate.getFullYear(), 0, 1);

		// let startDate 	=	weekData?.from 	?	weekData?.from 	:new Date();
		// let endDate 	=	weekData?.to 	? 	weekData?.to 	:new Date();


		this.state = {
			errors: {},
			fields: {
				start_date: { value: yearStartDate },
				end_date: { value: currentDate },
				date_range: [yearStartDate, currentDate],
			},
			selectedRangeType: "ytd",
			empList: [],
			submitted: false,
			bulkErrors: null,
			modalType: this.props.modalType
		};

		this.closeModal = this.closeModal.bind(this);
		// this.handleFormInputs 	= this.handleFormInputs.bind(this);
		// this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.loadOptions = this.loadOptions.bind(this);
	}

	componentDidMount() {
		this.getOnCallEmpList()
		window.document.body.classList.add("modal-open");
		window.document.body.classList.add("overflow-hidden");
	}

	handleQuickDateChange = (type) => {
		let startDate;
		let endDate;

		const currentDate = new Date();

		if (type === "ytd") {
			// Current year start -> today
			startDate = new Date(currentDate.getFullYear(), 0, 1);
			endDate = currentDate;
		} else if (type === "last_year") {
			// Full previous year
			startDate = new Date(currentDate.getFullYear() - 1, 0, 1);
			endDate = new Date(currentDate.getFullYear() - 1, 11, 31);
		}

		this.setState({
			selectedRangeType: type,
			fields: {
				...this.state.fields,
				date_range: [startDate, endDate],
				employee_ids: null
			}
		}, () => {
			this.getOnCallEmpList();
		});
	};

	getOnCallEmpList = () => {
		this.source = generateSource();
		window.showLoader();
		const { fields } = this.state;
		let startDate = (fields?.date_range && fields?.date_range[0]) || new Date();
		let endDate = (fields?.date_range && fields?.date_range[1]) || new Date();

		let empArr = [];
		if (fields?.employee_ids && fields.employee_ids.length) {
			empArr = fields.employee_ids.map(emp => emp.value);
		}

		callBackendAPI([{ model: 'on_call', method: 'list', history_report: true, employee_ids: empArr, start_date: startDate, end_date: endDate }], this.source).then(response => {
			window.hideLoader();
			if (response.success && response.data[0].status === STATUS_SUCCESS && response.data[0].skills) {
				this.setState({ empList: response.data[0].skills || [] });
			}
		}).catch(err => console.log(err));
	}

	handleExport = () => {
		this.source = generateSource();
		window.showLoader();
		const { fields } = this.state;
		let startDate = (fields?.date_range && fields?.date_range[0]) || new Date();
		let endDate = (fields?.date_range && fields?.date_range[1]) || new Date();

		let empArr = [];
		if (fields?.employee_ids && fields.employee_ids.length) {
			empArr = fields.employee_ids.map(emp => emp.value);
		}

		callBackendAPI([{ model: 'on_call', method: 'export-schedules', history_report: true, employee_ids: empArr, start_date: startDate, end_date: endDate }], this.source).then(response => {
			window.hideLoader();
			if (response.success && response.data[0].status === STATUS_SUCCESS) {
				if (response.data[0].file_url) {
					const link = document.createElement('a');
					link.href = response.data[0].file_url;
					link.rel = 'noopener noreferrer'; // Security for '_blank' links
					document.body.appendChild(link); // Required for Firefox
					link.click();
					document.body.removeChild(link);
				}
			}
		}).catch(err => console.log(err));
	}


	/**
	* For load project manager options
	*
	* @param inputValue		as 	search term
	* @param loadedOptions	as 	old options array
	* @param page			as 	page count
	*
	* @return json
	*/
	async loadOptions(inputValue, loadedOptions, { page }) {
		try {
			const { fields } = this.state;
			/** Generate source for cancel token */
			this.source = generateSource();


			let startDate = (fields?.date_range && fields?.date_range[0]) || new Date();
			let endDate = (fields?.date_range && fields?.date_range[1]) || new Date();

			let response = await callBackendAPI([{ model: 'on_call', method: 'list', compose_sms: true, emp_name: inputValue ? inputValue : '', start_date: startDate, end_date: endDate }], this.source);

			let resData = response && response.data && response.data[0] ? response.data[0] : {};
			let result = resData.skills ? resData.skills : [];

			return {
				options: result,
				hasMore: false,
				additional: { page: page + 1 },
			}

		} catch (error) {
			console.error('Error loading options:', error);
			return {
				options: [],
				hasMore: false,
				additional: { page: page },
			};
		}
	}

	/** Manage input change event */
	handleChange = (fieldName) => (fieldVal) => {
		this.setState((prevState) => {
			const newFields = { ...prevState.fields, [fieldName]: fieldVal };
			return { fields: newFields };
		});
	};

	/**
	* For hide model
	*
	* @return null
	*/
	closeModal() {
		window.document.body.classList.remove("modal-open");
		window.document.body.classList.remove("overflow-hidden");

		this.props.historyReportModal(false);
	}// end closeModal()


	render() {

		const { fields, empList } = this.state

		return <>
			<div
				className="modal fade on-call-modal d-block show"
				id="historyModal"
				tabIndex={-1}
				aria-labelledby="add-employeeModalLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog modal-lg">
					<div className="modal-content">
						<div className="modal-header">
							<h2 className="modal-title fs-5" id="historyModalLabel">{translate('on_call.history_report')}</h2>
							<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => this.closeModal()}></button>
						</div>
						<div className="modal-body">
							<div className="row filter-box top-0 mt-3">
								<div className="col-lg-12">
									<div className="form-group">
										<div className="d-flex justify-content-between mb-2 align-items-end">
											<label className="mb-1 form-label">{translate('on_call.date_range')} <span className='text-danger'>*</span></label>
											{/* <div className="btn-group history-date-suffle" role="group" aria-label="Basic radio toggle button group">
												<input type="radio" className="btn-check" name="btnradio" id="btnradio1" checked />
												<label className="btn btn-outline-primary" for="btnradio1">Year to Date</label>

												<input type="radio" className="btn-check" name="btnradio" id="btnradio2" />
												<label className="btn btn-outline-primary" for="btnradio2">Last Year</label>
											</div> */}
											<div
												className="btn-group history-date-suffle"
												role="group"
												aria-label="Basic radio toggle button group"
											>
												<input
													type="radio"
													className="btn-check"
													name="btnradio"
													id="btnradio1"
													checked={this.state.selectedRangeType === "ytd"}
													onChange={() => this.handleQuickDateChange("ytd")}
												/>

												<label
													className="btn btn-outline-primary"
													htmlFor="btnradio1"
												>
													{translate('on_call.year_to_date')}

												</label>

												<input
													type="radio"
													className="btn-check"
													name="btnradio"
													id="btnradio2"
													checked={this.state.selectedRangeType === "last_year"}
													onChange={() => this.handleQuickDateChange("last_year")}
												/>

												<label
													className="btn btn-outline-primary"
													htmlFor="btnradio2"
												>
													{translate('on_call.last_year')}
												</label>
											</div>
										</div>
										<CustomProvider locale={locale}>
											<DateRangePicker
												value={fields.date_range ? fields.date_range : null}
												format={DATE_RANGE_PICKER_FORMAT}
												size="lg"
												className='form-control input-with-label date-range-picker-common'
												onChange={(val) => {
													this.setState({
														fields: {
															...this.state.fields,
															date_range: val,
															employee_ids: null // reset selection
														}
													}, () => {
														this.getOnCallEmpList()
													});
												}}
												placeholder={translate('reports.search_by_date')}
												cleanable={false}
												ranges={[]}
												editable={false}
											/>
										</CustomProvider>
									</div>
								</div>
								<div className="col-lg-12">
									<div className="form-group multiselect-field">
										<label className="mb-1 form-label">{translate('on_call.employee')}</label>
										<AsyncPaginate
											key={`${fields?.date_range?.[0]}-${fields?.date_range?.[1]}`}
											className='custom-react-select '
											loadOptions={this.loadOptions}
											value={fields.employee_ids ? fields.employee_ids : null}
											onChange={this.handleChange("employee_ids")}
											isClearable={true}
											placeholder={translate("on_call.select_employee")}
											additional={{ page: 1 }}
											isMulti
										/>
									</div>
								</div>
								<div className="col-lg-12 mb-4">
									{/* <button type="button" className="btn btn-fill">{translate('on_call.generate_report')}</button> */}

									<button
										type="button"
										className="btn btn-fill"
										onClick={this.getOnCallEmpList}
									>
										{translate('on_call.generate_report')}
									</button>
								</div>
							</div>
							<div className="history-report-box">
								<div className="sp-week-banner">
									<p className="sp-week-range">
										<span>
											<strong className="me-1">{empList?.length || 0}</strong>
											employee{empList?.length !== 1 ? "s" : ""}
										</span>

										<span>
											<strong className="mx-1">
												{
													empList?.reduce(
														(total, emp) => total + (emp?.dates?.length || 0),
														0
													)
												}
											</strong>
											{translate('on_call.total_on_call_days')}
										</span>
									</p>
								</div>
								<div className="history-report-table">
									<div className='table-responsive'>
										<table className='table'>
											<thead>
												<tr>
													<th>{translate('on_call.employee_name')}</th>
													<th>{translate('on_call.department')}</th>
													<th>{translate('on_call.on_call_days')}</th>
													<th>{translate('on_call.scheduled_dates')}</th>
												</tr>
											</thead>
											<tbody>
												{empList && empList.length > 0 ?
													empList.map((val, index) => (
														<tr key={val?._id || index}>
															<td><strong>{val?.name || "N/A"}</strong></td>
															<td>
																{val?.department?.length
																	? val.department.map(d => (d || '').toUpperCase()).join(', ')
																	: "N/A"}
															</td>
															<td><strong>{val?.dates?.length || 0}</strong></td>
															<td>
																<span>{formatDate(val?.min_date, DATERANGE_DATE_TIME_FORMAT)}</span> -{" "}
																<span>{formatDate(val?.max_date, DATERANGE_DATE_TIME_FORMAT)}</span>
															</td>
														</tr>
													))
													:
													<tr>
														<td colSpan="4" className="text-center">{translate('on_call.no_records_found')}</td>
													</tr>
												}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-outline" data-bs-dismiss="modal" onClick={() => this.closeModal()}>Close</button>
							<button type="button" className="btn btn-fill" onClick={() => { this.handleExport() }}>{translate('on_call.export_to_excel')}</button>
						</div>
					</div>
				</div>
			</div>
			<div className="modal-backdrop fade show"></div>
		</>
	}
}